import styled from 'styled-components';

export const StyledImageWrapper = styled.div`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: ${({ theme }): string => {
    return theme.palette_blue_5;
  }};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${({ theme }): string => {
    return theme.spacing_unit_x1;
  }};

  img {
    max-width: 22px;
    max-height: 22px;
  }

  & > svg {
    max-width: 22px;
    max-height: 22px;
    fill: ${({ theme }): string => {
      return theme.palette_blue_100;
    }};
  }
`;
